import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NoResultComponent } from './no-result';
import { NoContentComponent } from './no-content';
import { SearchComponent } from './search';
import { CbPaginationComponent } from './cb-pagination';
import { ErrorAlertComponent } from './error-alert';

@NgModule({
  declarations: [
    NoResultComponent,
    NoContentComponent,
    SearchComponent,
    CbPaginationComponent,
    ErrorAlertComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    NgbModule
  ],
  exports: [
    NoResultComponent,
    NoContentComponent,
    SearchComponent,
    CbPaginationComponent,
    ErrorAlertComponent
  ]
})
export class DisplayModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/display.module.ts